/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CheckoutStatus {
    Pending = 'pending',
    Completed = 'completed',
    Expired = 'expired'
}

export function CheckoutStatusFromJSON(json: any): CheckoutStatus {
    return CheckoutStatusFromJSONTyped(json, false);
}

export function CheckoutStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckoutStatus {
    return json as CheckoutStatus;
}

export function CheckoutStatusToJSON(value?: CheckoutStatus | null): any {
    return value as any;
}

